import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useDispatch, useSelector } from "react-redux";
import { useNotifications } from "../../actions/dashboardActions";
import localimgpath from "../../js/localimgpath";
import Icons from "../../assets/icon/index";
import textWeight from "../../utils/textWeight";
export default () => {
  const [Profiler, setProfiler] = useState(false);
  const { TextWeight } = textWeight();
  const [notifications, setNotifications] = useState(false);
  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [islogout, setIslogout] = useState(false);
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const { data: allNotifications, refetch } = useNotifications(userId);
  const userprofile = useSelector((state) => state.app.userData.userData);
  const firstName = userprofile?.user?.first_name ?? "";
  const lastName = userprofile?.user?.last_name ?? "";
  const talentName = userprofile?.talent?.real_name ?? "";
  const employerName = userprofile?.employer?.name ?? "";
  const profileName =
    userprofile?.role === "fan"
      ? `${firstName} ${lastName}`.trim()
      : userprofile?.role === "talent"
      ? talentName
      : userprofile?.role === "employer"
      ? employerName
      : "";

  const profileimage =
    userprofile?.role === "fan"
      ? userprofile?.user?.image
        ? `${localimgpath?.usersProfile}/${userprofile?.user?.image}`
        : Icons.adimIcon
      : userprofile?.role === "talent"
      ? userprofile?.talent?.hero_image
        ? `${localimgpath?.talentThumbnail}/${userprofile?.talent?.hero_image}`
        : Icons.adimIcon
      : userprofile?.role === "employer"
      ? userprofile?.employer?.logo
        ? `${localimgpath?.companyLogo}/${userprofile?.employer?.logo}`
        : Icons.adimIcon
      : "";
  const timeoutRef = useRef(null);
  const notificationRef = useRef(null);

  const toggleSearchPopup = () => {
    setShowSearchPopup(!showSearchPopup);
  };
  // Profile Hover Functions
  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setProfiler(true);
    setNotifications(false);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setProfiler(false);
    }, 300);
  };

  // Notification Hover Functions
  const handleNotificationMouseEnter = () => {
    if (notificationRef.current) clearTimeout(notificationRef.current);
    setNotifications(true);
    setProfiler(false);
    refetch();
  };

  const handleNotificationMouseLeave = () => {
    notificationRef.current = setTimeout(() => {
      setNotifications(false);
    }, 300);
  };

  const notificationColorData = [
    {
      id: 1,
      bgcolor: "#FC7336",
    },
    {
      id: 2,
      bgcolor: "#D09B36",
    },
    {
      id: 3,
      bgcolor: "#2FCC6E",
    },
    {
      id: 4,
      bgcolor: "#FC7336",
    },
    {
      id: 5,
      bgcolor: "#D09B36",
    },
    {
      id: 6,
      bgcolor: "#2FCC6E",
    },
    {
      id: 7,
      bgcolor: "#FC7336",
    },
    {
      id: 8,
      bgcolor: "#D09B36",
    },
    {
      id: 9,
      bgcolor: "#2FCC6E",
    },
  ];
  // if (isError) {
  //     return (
  //         <div className="flex items-center justify-center w-full">
  //             <p className="text-secondary">Error loading notifications: {error.message}</p>
  //         </div>
  //     );
  // }
  return {
    Icons,
    toggleSearchPopup,
    showSearchPopup,
    userprofile,
    navigate,
    allNotifications,
    dispatch,
    logout,
    setIslogout,
    handleMouseLeave,
    handleNotificationMouseEnter,
    notifications,
    handleNotificationMouseLeave,
    handleMouseEnter,
    profileName,
    notificationColorData,
    profileimage,
    Profiler,
    islogout,
    setProfiler,
    TextWeight,
  };
};
